import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/contact/img_contact_qr_code.png'
import _imports_1 from '@/assets/contact/img_contact_phone.png'


const _withScopeId = n => (_pushScopeId("data-v-63be6cfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-root" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" style=\"width:25px;\" data-v-63be6cfa><span class=\"contact-text-white margin-top-10\" data-v-63be6cfa>扫</span><span class=\"contact-text-white\" data-v-63be6cfa>码</span><span class=\"contact-text-white\" data-v-63be6cfa>咨</span><span class=\"contact-text-white\" data-v-63be6cfa>询</span>", 5)
const _hoisted_7 = [
  _hoisted_2
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_1 + "\" style=\"width:22px;\" data-v-63be6cfa><span class=\"contact-text-black margin-top-10\" data-v-63be6cfa>电</span><span class=\"contact-text-black\" data-v-63be6cfa>话</span><span class=\"contact-text-black\" data-v-63be6cfa>联</span><span class=\"contact-text-black\" data-v-63be6cfa>系</span>", 5)
const _hoisted_13 = [
  _hoisted_8
]

import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}

const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "contact-qr-code",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onQRCodeClick()))
    }, _hoisted_7),
    _createElementVNode("div", {
      class: "contact-phone margin-top-20",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onPhoneClick()))
    }, _hoisted_13)
  ]))
}
}

})